module.exports = __webpack_public_path__ + "static/media/gif.7ec162d9.gif";